export default "__VITE_ASSET__D5kOz$e3__"